export const getCallersOptions = (t) => [
  { key: 'one', label: t('One Caller') },
  { key: 'two_to_four', label: t('Between 2-4 callers') },
  { key: 'more_than_five', label: t('More than 5 callers') },
];

export const getNationalityOptions = (t) => [
  { key: 'saudi', label: t('Saudi') },
  { key: 'non_saudi', label: t('Non-Saudi') },
];

